import PropTypes from 'prop-types';
import React from 'react';
import { usePlaidLink } from 'react-plaid-link';

import Button from 'components/atomic/Button';

const PlaidLinkButton = ({
  receivedRedirectUri,
  token,
  onSuccess,
  onExit,
  onEvent,
  onLoad,
  children,
  ...restProps
}) => {
  const { open, ready } = usePlaidLink({ receivedRedirectUri, token, onSuccess, onExit, onEvent, onLoad });

  const handleClick = () => {
    if (ready) {
      open();
    }
  };

  return (
    <Button {...restProps} onClick={handleClick}>
      {children}
    </Button>
  );
};

PlaidLinkButton.propTypes = {
  children: PropTypes.node,
  token: PropTypes.string,
  onSuccess: PropTypes.func,
  onExit: PropTypes.func,
  onEvent: PropTypes.func,
  onLoad: PropTypes.func,
  receivedRedirectUri: PropTypes.string,
};

export default PlaidLinkButton;
